var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Headline } from '../Headline';
export const Text = React.forwardRef((_a, ref) => {
    var { bold, children, className, el: TextElement = 'p', headline, inline, italic, size = 3, subdued } = _a, props = __rest(_a, ["bold", "children", "className", "el", "headline", "inline", "italic", "size", "subdued"]);
    React.useEffect(() => {
        console.warn('@servicetitan/design-system: The Text component will be deprecated. Please use Headline, BodyText, or Eyebrow component instead.');
        if (!headline)
            return;
        console.warn('@servicetitan/design-system: The `headline` prop of the Text component has been deprecated. Please use `bold` instead.');
    });
    const TextClasses = classnames('Text', className, {
        [`fs-${size}`]: !inline,
        'fw-bold': bold || headline,
        'fw-normal': !bold && bold != null,
        'd-i': inline,
        'fs-italic': italic,
        'fs-normal': !italic && italic != null,
        'c-neutral-90': subdued,
        'ff-display lh-display fw-bold': size === 7 || size === '7',
    });
    if (size === 6 || size === '6') {
        const headlineProps = Object.assign({ children,
            className,
            inline,
            italic,
            subdued }, props);
        return (React.createElement(Headline, Object.assign({ ref: ref, size: "xlarge", el: TextElement }, headlineProps)));
    }
    return (React.createElement(TextElement, Object.assign({ ref: ref, className: TextClasses, "data-anvil-component": "Text" }, props), children));
});
//# sourceMappingURL=Text.js.map